<template>
  <div class="text-left">
    <mdb-row v-for="host in event.hosts" :key="host.id">
      <mdb-col col="3">
      <mdb-chip :alt="host.name" :src="host.avatar" size="lg" waves>
        {{host.name}}
      </mdb-chip>
      </mdb-col>
      <mdb-col col="9" v-if="!event.hostNotParticipant && mayRemoveHost(host)">
        <mdb-btn :disabled="executing" rounded size="sm" @click="removeHost(host,true)" color="warning">
          {{$t("page.event.removeHostGoing")}}
        </mdb-btn>
        <br/>
        <mdb-btn :disabled="executing" rounded size="sm" color="danger" @click="removeHost(host,false)">
          {{$t("page.event.removeHostNotGoing")}}
        </mdb-btn>
      </mdb-col>
      <mdb-col col="9" v-if="event.hostNotParticipant && mayRemoveHost">
        <mdb-btn :disabled="executing" rounded size="sm" @click="removeHost(host,false)" color="warning">
          {{$t("page.event.removeHost")}}
        </mdb-btn>
      </mdb-col>
    </mdb-row>
    <hr/>
    <mdb-input @input="isTyping = true" aria-label="Find a Person to Add" :placeholder="'Find ' + memberWithArticle + ' to add'" type="text"
               v-model="query"/>

    <mdb-row v-for="member in memberList" :key="member.id">
      <mdb-col col="3">
        <mdb-chip :alt="member.name" :src="member.avatar" size="lg" waves>
          {{member.name}}
        </mdb-chip>
      </mdb-col>
      <mdb-col col="9">
        <mdb-btn rounded size="sm" @click="addHost(member)" color="green">Add as Host</mdb-btn>
      </mdb-col>
    </mdb-row>
      <mdb-btn @click="doCancel" :disabled="executing" color="success" icon="times-circle">Done</mdb-btn>
    <mdb-btn v-if="queryTotal > 10 && memberList.length >= 10 " :disabled="executing" @click="nextPage" color="success" icon="arrow-right">
      Load More
    </mdb-btn>
    <mdb-btn v-if="resultsPage > 0 " :disabled="executing" @click="previousPage" color="success" icon="arrow-left">
      Previous
    </mdb-btn>
    <div v-if="showSeriesModal">
      <series-modal @closeModal="cancelSeriesChoice" @seriesChoice="setSeriesChoice"/>
    </div>
  </div>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbChip, mdbCol, mdbIcon, mdbInput, mdbRow, mdbTooltip} from 'mdbvue';
import SeriesModal from "./SeriesModal";
import articles from "articles";

export default {
    name: 'Event-Hosts-Editor',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbRow,
      mdbCol,
      mdbChip,
      mdbTooltip,
      SeriesModal
    },
    props: {
      event: {
        type: Object,
        default: []
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      },
      settings() {
        return this.$store.state.settings
      },
      memberWithArticle() {
        return articles.articlize(this.$tc("common.label.member",1))
      }
    },
    watch: {
      query: _.debounce(function () {
        this.isTyping = false;
      }, 790),
      isTyping: function (value) {
        if (!value) {
          this.loadMemberList(true)
        }
      }
    },
    data() {
      return {
        showSeriesModal: false,
        seriesChoice: null,
        query: "",
        isTyping: false,
        memberList: [],
        queryTotal: 0,
        resultsPage: 0,
        saveAction: null,
        saveHost: null,
        stillGoing: false
      }
    },
    methods: {
      mayRemoveHost(host) {
        if (this.group.role != "Event Organizer") return true
        if (host.userId == this.userDetails.id) return false
        return true
      },
      nextPage() {
        this.resultsPage++
        this.loadMemberList(false)
      },
      previousPage() {
        this.resultsPage--
        this.loadMemberList(false)
      },
      loadMemberList(reset) {
        if (reset) this.resultsPage = 0
        if (!this.query) return
        this.memberList = []
        this.$store.dispatch("setExecuting", true)
        api.get("/member/lookup/" + this.group.vanityPath + "/?q=" + this.query + "&offset=" + this.resultsPage * 10).then(
          (results) => {
            this.queryTotal = results.data.total
            for (let i=0; i<results.data.members.length; i++) {
              let row = results.data.members[i]
              if (!this.isHost(row.id)) this.memberList.push(row)
            }
          },
          (error) => {
            this.$notify.error({message: "Could not load hosts. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      isHost(id) {
        let found = false
        for (let i=0; i<this.event.hosts.length; i++) {
          if (this.event.hosts[i].id == id) found = true
        }
        return found
      },
      doCancel() {
        this.$emit("cancel")
      },
      cancelSeriesChoice() {
        this.event.series = null
        this.showSeriesModal = false
      },
      setSeriesChoice(choice) {
        this.event.series = choice
        this.showSeriesModal = false
        if (this.saveAction == "add") this.addHost(this.saveHost)
        else this.removeHost(this.saveHost, this.stillGoing)
      },
      removeHost(host,stillGoing) {
        if ( (this.event.repeats || this.event.isRepeatChild) && !this.event.series && this.event.status != "Draft") {
          this.saveHost = host
          this.saveAction = "remove"
          this.stillGoing = stillGoing
          this.showSeriesModal = true
          return
        }
        let payload = { mode:"remove", id:host.id,
          stillGoing: stillGoing, series: this.event.series}
        this.$store.dispatch("setExecuting", true);
        api.post('/event/host/' + this.event.eventId, payload).then(
          (results) => {
            let loc = this.event.hosts.indexOf(host)
            this.event.hosts.splice(loc,1)
            this.event.series = null
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        });

      },
      addHost(host) {
        this.query = ""
        this.memberList = []
        if ( (this.event.repeats || this.event.isRepeatChild) && !this.event.series && this.event.status != "Draft") {
          this.saveHost = host
          this.saveAction = "add"
          this.showSeriesModal = true
          return
        }
        let payload = { mode:"add", id:host.id,
                series: this.event.series}
        this.$store.dispatch("setExecuting", true);
        api.post('/event/host/' + this.event.eventId, payload).then(
          (results) => {
            this.event.hosts.push(host)
            this.event.series = null
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        });
      }
    }
  }
  ;
</script>
